// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"src-components-Modules-Components-ModuleStyle-css-module__checkboxContainer--WJ9tt"};